import { AlertToken } from "../alerts";
import { ResidentActivityType, SubActivityType } from "../residentActivityPlan";

export const NEW_NOTIFICATION = {
  NEW_NOTIFICATION_APPEARS: "NEW_NOTIFICATION.NEW_NOTIFICATION_APPEARS",
  NEW_NOTIFICATION_VIEW: "NEW_NOTIFICATION.NEW_NOTIFICATION_VIEW",
  NEW_NOTIFICATION_CONFIRM: "NEW_NOTIFICATION.NEW_NOTIFICATION_CONFIRM",
  NEW_NOTIFICATION_VIEW_FEEDBACK:
    "NEW_NOTIFICATION.NEW_NOTIFICATION_VIEW_FEEDBACK",
  NEW_NOTIFICATION_CONGRAT: "NEW_NOTIFICATION.NEW_NOTIFICATION_CONGRAT",
  NEW_NOTIFICATION_CLEAR: "NEW_NOTIFICATION.NEW_NOTIFICATION_CLEAR",
};
export type AppStateNotification = {
  notifications: OneNotification[];
};
export enum NotificationState {
  new,
  view,
  confirm,
  feedback,
  congrat,
}
export type OneNotification = {
  residentId: string;
  type: AlertToken | ResidentActivityType;
  datetime?: string;
  state: NotificationState;
  activityParams?: SubActivityType[];
};

export interface INotificationNew {
  type: typeof NEW_NOTIFICATION.NEW_NOTIFICATION_APPEARS;
  payload: OneNotification;
}

export interface INotificationView {
  type: typeof NEW_NOTIFICATION.NEW_NOTIFICATION_VIEW;
  payload: OneNotification;
}
export interface INotificationViewFeedback {
  type: typeof NEW_NOTIFICATION.NEW_NOTIFICATION_VIEW_FEEDBACK;
  payload: OneNotification;
}

export interface INotificationCongrat {
  type: typeof NEW_NOTIFICATION.NEW_NOTIFICATION_CONGRAT;
  payload: OneNotification;
}

export interface INotificationClear {
  type: typeof NEW_NOTIFICATION.NEW_NOTIFICATION_CLEAR;
  payload: OneNotification;
}
export interface INotificationConfirm {
  type: typeof NEW_NOTIFICATION.NEW_NOTIFICATION_CONFIRM;
  payload: OneNotification;
}

export const isFeedbackType = (el: AlertToken | ResidentActivityType) => {
  if (Object.values(AlertToken).indexOf(el as AlertToken) === -1) return true;
  return (
    [
      AlertToken.Fall,
      AlertToken.FallDetected,
      AlertToken.TurnResident,
      AlertToken.InBed,
      AlertToken.OutOfBed,
      AlertToken.AwayFromBed,
    ].indexOf(el as AlertToken) !== -1
  );
};

export type NotificationActionTypes =
  | INotificationNew
  | INotificationView
  | INotificationViewFeedback
  | INotificationCongrat
  | INotificationClear
  | INotificationConfirm;
